import { InputField } from '@/components/Form';
import { MAX_SEARCH_KEYWORD_LENGTH } from '@/config';
import { MagnifyingGlassIcon } from '@heroicons/react/16/solid';
import { useTranslation } from 'react-i18next';

type SearchFieldProps = {
  value?: string;
  onSubmit: () => void;
  leftIcon?: React.ReactNode;
  onChange: (value: string) => void;
};

export const SearchField = ({
  value,
  onSubmit,
  leftIcon,
  onChange,
}: SearchFieldProps) => {
  const { t } = useTranslation();

  const handleOnSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    onSubmit();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <form onSubmit={handleOnSubmit}>
      <InputField
        type="text"
        name="search-query"
        className="border-2 shadow-none"
        rounded="3xl"
        leftIcon={leftIcon}
        icon={
          <button
            type="submit"
            className="rounded-3xl bg-primary-dark-teal px-2 py-0.5 text-white"
          >
            <MagnifyingGlassIcon className="size-6" />
          </button>
        }
        value={value}
        onChange={handleInputChange}
        placeholder={t('検索')}
        maxLength={MAX_SEARCH_KEYWORD_LENGTH}
      />
    </form>
  );
};
